<ng-container *ngIf="!small; else smallTemplate">
  <div class="color-picker" [matMenuTriggerFor]="menu">
    <div class="value" [style.background-color]="control.value"></div>
    <mat-icon>arrow_drop_down</mat-icon>
  </div>
</ng-container>

<ng-template #smallTemplate>
  <div class="value value-pointer" [style.background-color]="control.value" [matMenuTriggerFor]="menu"></div>
</ng-template>

<mat-menu #menu="matMenu" class="menu-with-backdrop">
  <div class="options">
    <label *ngIf="!smallTemplate" class="uppercase">Colors</label>
    <div class="variants">
      <div
        (click)="control.setValue(color)"
        *ngFor="let color of colors"
        class="value"
        [class.selected]="color === control.value"
        [style.background-color]="color"></div>
    </div>
  </div>
</mat-menu>
